// src/services/erros.js
//
// Traduz a resposta de erro do Django REST Framework em uma frase legivel.
//
// Por que existe: o DRF responde 400 com um objeto por campo,
//   { "phone": ["Este campo é obrigatório."], "cpf": ["Já existe..."] }
// e as telas liam so err.response.data.error ou .message. Como nenhuma
// dessas duas chaves existe nessa resposta, o usuario via sempre a frase
// generica de fallback - o servidor dizia exatamente o que estava errado e
// a tela jogava fora. Perfil ficou com "Erro ao atualizar perfil" por dias.

// Nomes de campo em portugues, para a frase nao sair em snake_case.
const ROTULOS = {
  first_name: 'Nome',
  last_name: 'Sobrenome',
  email: 'E-mail',
  phone: 'Telefone',
  cpf: 'CPF',
  cnpj: 'CNPJ',
  creci: 'CRECI',
  company_name: 'Razão social',
  business_phone: 'Telefone comercial',
  avatar: 'Foto',
  password: 'Senha',
  current_password: 'Senha atual',
  new_password: 'Nova senha',
  non_field_errors: ''
}

const achatar = (v) => {
  if (Array.isArray(v)) return v.map(achatar).join(' ')
  if (v && typeof v === 'object') return Object.values(v).map(achatar).join(' ')
  return String(v)
}

/**
 * @param {unknown} err        erro do axios
 * @param {string} padrao      frase usada quando nao da para extrair nada
 * @returns {string}
 */
export const mensagemDeErro = (err, padrao = 'Não foi possível concluir.') => {
  const d = err && err.response && err.response.data

  if (!d) {
    // Sem resposta: ou a rede caiu, ou o pedido estourou o timeout.
    if (err && err.code === 'ECONNABORTED') return 'O servidor demorou demais para responder. Tente de novo.'
    return 'Sem conexão com o servidor. Verifique sua internet e tente de novo.'
  }
  if (typeof d === 'string') return d.slice(0, 300)

  // Formatos que o proprio projeto usa em algumas views
  if (d.error) return achatar(d.error)
  if (d.detail) return achatar(d.detail)
  if (d.message) return achatar(d.message)

  // Formato padrao do DRF: um array de mensagens por campo
  const partes = Object.entries(d).map(([campo, msgs]) => {
    const texto = achatar(msgs)
    const rotulo = ROTULOS[campo] !== undefined ? ROTULOS[campo] : campo
    return rotulo ? `${rotulo}: ${texto}` : texto
  })

  return partes.length ? partes.join(' · ') : padrao
}

export default mensagemDeErro
